"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logDependencies = void 0;

var _dependenciesComplexClassGenerated = require("./dependenciesComplexClass.generated.js");

var _dependenciesDivideScalarGenerated = require("./dependenciesDivideScalar.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var logDependencies = {
  ComplexDependencies: _dependenciesComplexClassGenerated.ComplexDependencies,
  divideScalarDependencies: _dependenciesDivideScalarGenerated.divideScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createLog: _factoriesAny.createLog
};
exports.logDependencies = logDependencies;